import type {
  Coupon,
  ImageAsset,
  Item,
  Order,
  OutputAsset,
  Subscription,
  SubscriptionKind,
  SubscriptionV2,
  Workflow
} from '.'
import type { ContactPoint } from './contactPoint.interface'
import type { Credit } from './credit.interface'
import type { Job } from './job.interface'
import type { ObjectBase } from './objectBase.interface'
import type { Promotion } from './promotion.interface'

export type AuthUser = NordyUser<
  ImageAsset,
  SubscriptionV2<string, Item>,
  ContactPoint
> & {
  signupSuccess?: boolean //TODO GA 수집용인데 안쓸수도 있음. 그냥 백엔드에서 쏠수도
  price_type?: 'free' | 'credit' | 'subscription'
  //!nordy - 쿠폰 구독 만료(→Free 전환) 후 첫 GET /auth에서만 true. 서버가 응답과 동시에 소비하므로 1회성. 결제유도 모달 트리거.
  couponExpiredModal?: boolean
  //!nordy - (역정규화) 백엔드 GET /auth가 내려주는 구독 미러필드. 무구독(active 구독 0개)=Free 모델이라 항상 최소 'Free'.
  // 권위(SSOT)는 구독 docs이고 이 값은 핫패스 캐시 — populate된 subscriptions[] 대신 이걸 참조한다.
  subscriptionItemName?: string | null
  subscriptionItemKind?: SubscriptionKind | null
}
export enum UserRole {
  Admin = 'Admin',
  Customer = 'Customer'
}

export enum UserLanguage {
  en = 'en',
  ko = 'ko'
}

export enum NsfwMode {
  View = 'View',
  Hide = 'Hide',
  Only = 'Only'
}

export interface LanguageSet<Type = string> {
  en: Type
  ko: Type
}

export interface NordyUser<
  ImageAsset = string,
  Subscription = string,
  ContactPoint = string
> extends ObjectBase {
  _id: string
  // password: string;
  // apiKey: string;
  name: string
  nameTag: string // unique name + tag(#KR1)
  email: string
  roles: UserRole[]
  profile: ImageAsset
  socialProfile: string
  apiKey: string
  meta?: {
    // google?: GoogleUser;
    // discord?: DiscordUser;
    workflowCount: number
    outputAssetCount: number
    jobCount: number
  }
  language?: UserLanguage
  nsfw?: NsfwMode
  workflows?: Workflow[]
  outputAssets?: OutputAsset[]
  jobs?: Job[]
  credits?: Credit[]
  subscriptions?: Subscription[]
  contactPoints?: ContactPoint[]
}

export interface RemoveUser extends NordyUser {
  originCreatedAt: Date
  originUpdatedAt: Date
  removedAt: Date
}

export interface GoogleUser {
  email: string // 'shpark@gaonprime.com';
  family_name: string // 'park';
  given_name: string // 'sunghyun';
  hd: string // 'gaonprime.com';
  id: string // '1number7796505728717915141';
  locale: string // 'ko';
  name: string // 'sunghyun park';
  picture: string // 'https://lh3.googleusercontent.com/a/ACg8ocKdzy93v_XpcYeLxP12LTfuftecMNF0ysLTRAXraR4w=s96-c';
  verified_email: boolean //true;
}

export interface DiscordUser {
  id: string
  username: string
  discriminator: string
  avatar: string | null
  public_flags: number
  premium_type: number
  flags: number
  banner: string | null
  accent_color: string | null
  global_name: string
  avatar_decoration_data: string | null
  banner_color: string | null
  mfa_enabled: boolean
  locale: string
  email: string
  verified: boolean
}

export interface UserForStats extends Omit<
  NordyUser<
    string,
    Subscription<
      string,
      Item,
      string,
      Order<string, string, string, Coupon<string, string, Promotion>>
    >
  >,
  'workflows' | 'outputAssets' | 'credits' | 'jobs'
> {
  totalDays: number
  totalPublicWorkflows: number
  totalPublicOutputAssets: number
  jobCountForJobRange: number
  totalDurationForJobRange: number
}

export interface UserForStatsV2 extends Omit<
  NordyUser<string, SubscriptionV2<string, Item, string>>,
  'workflows' | 'outputAssets' | 'credits' | 'jobs'
> {
  totalDays: number
  totalPublicWorkflows: number
  totalPublicOutputAssets: number
  jobCountForJobRange: number
  totalDurationForJobRange: number
}

export interface UserCycle {
  maxEmptyStreak: number
  maxUsedStreak: number
  groupedAssetsKST: { date: string; count: number }[]
}
